import React, { useState, useEffect } from "react";
import MainButton from "../../button/MainButton";
import ReusableModal from "../../modal/ReusableModal";

interface GarmentMeasurementTourModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoUrl: string;
}

const GarmentMeasurementTourModal: React.FC<GarmentMeasurementTourModalProps> = ({ isOpen, onClose, videoUrl }) => {
  const [videoError, setVideoError] = useState(false);

  useEffect(() => {
    setVideoError(false);
  }, [videoUrl]);

  const handleVideoError = () => {
    setVideoError(true);
  };

  return (
    <ReusableModal isOpen={isOpen} onClose={onClose} customModal>
      <div className="flex flex-col items-start p-6 overflow-auto bg-white rounded-xl max-w-[40rem] max-h-[90vh] w-full md:min-w-80">
        <h2 className="w-full mb-4 text-base font-bold max-w-[16rem] sm:max-w-none text-closed-shutter-500">Garment Measurement Service Guide</h2>

        {!videoError ? (
          <div className="flex justify-center w-full my-4">
            <video className="w-full rounded-lg bg-gorgonzola-blue-50 max-w-80 " autoPlay loop muted controls onError={handleVideoError}>
              <source src={videoUrl} type="video/webm" />
              Your browser does not support the video tag.
            </video>
          </div>
        ) : (
          <div className="flex items-center justify-center w-full p-8 mb-6 rounded-lg aspect-video bg-gorgonzola-blue-50">
            <p className="text-gorgonzola-blue-800">Tutorial video will be available soon</p>
          </div>
        )}

        <div className="flex flex-col w-full max-w-2xl gap-4 p-4 border rounded-lg border-gorgonzola-blue-50">
          <div className="flex gap-2 font-bold text-gorgonzola-blue-300">
            <h3>Guidelines for accurate measurements:</h3>
          </div>
          <ul className="space-y-2 text-xs list-disc ps-6 text-closed-shutter-300">
            <li>Ensure the garment is a T-shirt.</li>
            <li>Capture the entire front of the T-shirt in portrait orientation (no tilted or rotated images).</li>
            <li>Place a flat A4 sheet next to the T-shirt for scale (not on top) and ensure it has no folds or wrinkles.</li>
            <li>Make sure all corners of both the T-shirt and the A4 sheet are fully visible.</li>
            <li>Use a flat surface with a plain, uncluttered background.</li>
            <li>Avoid shadows for accurate measurements.</li>
          </ul>
        </div>

        <div className="flex justify-end w-full mt-2">
          <MainButton customClass="w-full justify-center" onClick={onClose}>
            Continue
          </MainButton>
        </div>
      </div>
    </ReusableModal>
  );
};

export default GarmentMeasurementTourModal;
